<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.firstName"
        label="Athlete Name"
        :rules="nameRules"
        :counter="50"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.lastName"
        label="Athlete Last Name"
        :rules="nameRules"
        :counter="50"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.email"
        label="E-Mail"
        :rules="emailRules"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 v-if="!hideTeam">
      <v-autocomplete
        v-model="editedItem.teamId"
        :rules="requiredRule"
        :dark="dark"
        @blur="sendDataToParent"
        required
        :hint="`${editedItem.teamId}`"
        label="Select Group Name"
        :items="groupList"
        item-value="node.teamId"
        item-text="node.teamName"
        chips
      >
      </v-autocomplete>
    </v-flex>
    <v-flex xs12 sm6 v-if="!hideLang">
      <v-text-field
        v-model="editedItem.language"
        label="Language"
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 v-if="!hideCountry">
      <v-text-field
        v-model="editedItem.country"
        :dark="dark"
        @blur="sendDataToParent"
        label="Country"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 v-if="!hideStatus">
      <v-select
        v-model="editedItem.status"
        :items="['inactive', 'active']"
        label="Status"
        :dark="dark"
        @blur="sendDataToParent"
        :rules="requiredRule"
        required
      ></v-select>
    </v-flex>
    <v-flex xs12 sm6>
      <v-select
        v-model="editedItem.gender"
        :items="['male', 'female']"
        label="Gender"
        :dark="dark"
        @blur="sendDataToParent"
        :rules="requiredRule"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm6 v-if="!hidePhoto">
      <v-text-field
        v-model="editedItem.photo"
        :dark="dark"
        @blur="sendDataToParent"
        label="Photo"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 v-if="showPhone">
      <v-text-field
        v-model="editedItem.phone"
        label="Phone"
        type="number"
        :rules="phoneRules"
        required
        :dark="dark"
        :hint="'1xxxyyyzzzz'"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :dark="dark"
        @blur="sendDataToParent"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="editedItem.birthDate"
            label="Birth Date"
            prepend-inner-icon="event"
            v-on="on"
            :dark="dark"
            @blur="sendDataToParent"
            v-bind="attrs"
            :rules="requiredRule"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="editedItem.birthDate"
          @input="menu = false"
          required
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 sm6 v-if="info">
      <catValueDropDown
        :darkMode="true"
        :outlined="true"
        label="Where did you hear about Us"
        catName="CLUB_LEADS"
        v-model="editedItem.info"
        :multiList="true"
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.additionalInfo"
        label="Previous Swimming Expirience"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>    
  </v-layout>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapActions } from "vuex";
import catValueDropDown from "../shared/cat_val_dropdown.vue";

export default {
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      tab: "Novice",
      isFormValid: true,
      status: "inactive",
      search: "",      
      loadingTable: true,
      dialog: false,
      menu: false,
      //TODO Take out this validation rules. We have the same in global const
      name: "Default",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || // eslint-disable-line
          "E-mail must be valid",
      ],
      phoneRules: [
        v => !!v || "Phone number is required",
        v =>
          /^\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}$/.test(v) ||
          "Phone number must be valid"
      ],
      editedIndex: -1,
      editedItem: {
        firstName: "",
        lastName: "",
        status: 0,
        birthDate: "",
        photo: "",
        info: "",
        gender: 0,
        phone: 1,
        email: "",
        language: "",
        country: 0,
        teamId: 1,
        additionalInfo: "",        
      },
      //TODO Take out this hardcode
      defaultItem: {
        firstName: "",
        lastName: "",
        status: 0,
        birthDate: "",
        photo: "",
        info: "",
        phone: 1,
        gender: 0,
        email: "",
        language: "",
        country: 0,
        teamId: 0,
        additionalInfo: "",        
      },
    };
  },
  async created() {
    this.editedItem.status = "tryout";

    await this.allAthlete({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        this.loadingTable = false;
        console.error(error);
      });
    await this.allClub({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        console.error(error);
        this.loadingTable = false;
      });

    if (!(Object.entries(this.$route.query).length === 0)) {
      const { tab } = this.$route.query;
      this.tab = tab;

      // this.tab = this.categoryList.edges.findIndex((item) => item.node.catName == tab);
    }
  },
  props: {
    dark: Boolean,
    hidePhoto: {
      type: Boolean,
      default: false
    },
    hideLang: {
      type: Boolean,
      default: false
    },
    hideCountry: {
      type: Boolean,
      default: false
    },
    hideStatus: {
      type: Boolean,
      default: false
    },
    StatusInactive: {
      type: Boolean,
      default: false
    },
    hideTeam: {
      type: Boolean,
      default: false
    },
    showPhone: {
      type: Boolean,
      default: false
    },
    teamName: {
      type: String,
      default: "TRYOUT"
    },
    info: {
      type: Boolean,
      default: false
    },
    additionalInfo: {
      type: Boolean,
      default: false
    },    
    teamId: {
      type: Number,
      default: 1
    },
  }, computed: {
    ...mapGetters(["loading", "athleteList", "groupList", "user", "hasUser"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Athlete" : "Edit Athlete";
    },
    funcName() {
      return this.editedIndex === -1 ? this.addNewAthlete : this.editAthlete;
    },
    groupListFiltered() {
      //console.log(this.groupList);
      if (this.groupList) {
        return this.groupList.filter(
          (item) =>
            item &&
            (item.node.teamName.toLowerCase() != "inactive" ||
              (this.user && this.user.role == "Administrator"))
        ).sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
      } else {
        return [];
      }
    }, // contains only Alex and James
    // Dynamic header to hide sensetive fields:
    headers() {
      let headers = [
        {
          text: "Athlete Name",
          align: "left",
          sortable: true,
          value: "node.firstName",
        },
        { text: "Athlete Last Name", value: "node.lastName" },
      ];

      if (this.user && this.user.role == "Administrator") {
        headers.push({ text: "Birth Date", value: "node.birthDate" });
        headers.push({ text: "Email", value: "node.email" });
        headers.push({ text: "TeamId", value: "node.teamId" });
        headers.push({ text: "Status", value: "node.status" });
        headers.push({ text: "Actions", value: "action", sortable: false });
      }

      return headers;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    ...mapActions([
      "allAthlete",
      "allClub",
    ]),
    sendDataToParent() {
      this.$emit('childData', this.editedItem);
    },

    getTeamName: function (item) {
      return this.groupList.find((x) => x.node.teamId == item).node.teamName;
    },

    getTabName(el) {
      if (this.athleteList.edges) {
        const athleteQuantity = this.athleteList.edges.filter(
          (item) =>
            item.node.teamId == el.node.teamId && item.node.status === "active"
        ).length;
        return `${el.node.teamName}(${athleteQuantity})`;
      } else {
        return "";
      }
    },


    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
  },
  components: { catValueDropDown }

};
</script>

<!--style module>
  
   body {
     height: auto;
     width: auto;
     margin: auto;
     overflow: scroll;
  }
  @media print {
    body { 
      overflow: auto;
      height: auto; 
    }
  }
  
  </style-->